import { render, staticRenderFns } from "./TempConfigCostCategoryList.vue?vue&type=template&id=08eddbb3&scoped=true"
import script from "./TempConfigCostCategoryList.vue?vue&type=script&lang=js"
export * from "./TempConfigCostCategoryList.vue?vue&type=script&lang=js"
import style0 from "./TempConfigCostCategoryList.vue?vue&type=style&index=0&id=08eddbb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eddbb3",
  null
  
)

export default component.exports